<template>
  <van-field
    v-model="position"
    is-link
    readonly
    name="point"
    label="位置"
    placeholder="选择位置"
    @click="showPopup"
  />
  <popup title="选择位置" ref="popup">
    <div class="search-container">
      <van-search
        v-model="word"
        placeholder="请输入搜索关键词"
        input-align="center"
        @search="handleSearch"
      />
    </div>
    <div class="bmap" ref="bmap"></div>
  </popup>
</template>

<script>
import { nextTick, ref } from 'vue'
import { Toast } from 'vant'
// import BMapGL from 'BMapGL'
export default {
  name: 'SelectPoint', // 选择坐标
  emits: ['get-value'],
  setup(props, { emit }) {
    const word = ref('')
    const position = ref('')
    const popup = ref(null)
    let map = null
    let localSearch = null
    const showPopup = async () => {
      popup.value.show = true
      await nextTick()
      if (!map) {
        loadMap()
      }
    }

    // 位置
    // const mapvgl = require('mapvgl')
    const bmap = ref(null)
    const loadMap = () => {
      // 1.初始化
      map = new BMapGL.Map(bmap.value)
      const point = new BMapGL.Point(115.985371, 36.456703) // 创建点坐标
      map.centerAndZoom(point, 16) // 初始化地图，设置中心点坐标和地图级别
      map.addEventListener('click', (e) => {
        const { lat, lng } = e.latlng
        emit('get-value', [lat, lng])
        position.value = `${lat}, ${lng}`
        setTimeout(() => {
          Toast(`选择坐标：${[lat, lng]}`)
          popup.value.show = false
        }, 10)
      })
      // map.enableScrollWheelZoom(true)
      const zoomCtrl = new BMapGL.ZoomControl() // 添加缩放控件
      map.addControl(zoomCtrl)

      // 2.定位
      const myCity = new BMapGL.LocalCity()
      myCity.get((result) => {
        const cityName = result.name
        map.setCenter(cityName)
      })

      // search
      localSearch = new BMapGL.LocalSearch(map, {
        renderOptions: { map: map }
      })
    }

    const handleSearch = () => {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '请稍等...'
      })
      localSearch.search(word.value)
      localSearch.setSearchCompleteCallback(res => {
        Toast.clear()
        // var poi = res.getPoi(0)
        // map.centerAndZoom(poi.point, 19)
        // console.log(res.getPoi(0), localSearch)
      })
    }
    return {
      position,
      popup,
      showPopup,
      bmap,
      word,
      handleSearch
    }
  }
}
</script>

<style lang="scss" scoped>
.bmap {
  height: calc(100vh - 50px)
}
.search-container {
  position: absolute;
  top: 50px;
  left: 0px;
  right: 0px;
  z-index: 10;
}
</style>
